export default __webpack_public_path__ + "static/media/add.538ee209.png";